import { ApprovalRequestSource, ApprovalRequestType } from "../types/approval-request";
import { CacheKey } from "../types/cache-keys";


export const createCacheKeyForApprovalRequest = (approvalType: ApprovalRequestType, rootObjectIds: Record<string, any>) => {
  let ids: Record<string, number | string> = {};
  switch (approvalType) {
    case ApprovalRequestType.Escalation:
      ids = {
        [ApprovalRequestSource.Opportunity]: rootObjectIds[ApprovalRequestSource.Opportunity],
      };
      break;
    case ApprovalRequestType.PoV:
      ids = {
        [ApprovalRequestSource.Opportunity]: rootObjectIds[ApprovalRequestSource.Opportunity],
        [ApprovalRequestSource.PoV]: typeof rootObjectIds[ApprovalRequestSource.PoV] === 'object'
          ? rootObjectIds[ApprovalRequestSource.PoV]?.id
          : rootObjectIds[ApprovalRequestSource.PoV],
        [ApprovalRequestSource.OpportunityProduct]: typeof rootObjectIds[ApprovalRequestSource.OpportunityProduct] === 'object'
          ? rootObjectIds[ApprovalRequestSource.OpportunityProduct]?.id
          : rootObjectIds[ApprovalRequestSource.OpportunityProduct],
      };
      break;
    default:
      ids = rootObjectIds;
  }

  return [CacheKey.ApprovalRequest, approvalType, ...Object.values(ids)].map(String);
}